import { BreadCrumb, ModalWrapper } from 'Components'
import { Key, useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import './InvestorsKycDetails.scss'
import { formatString } from 'Helpers/formatString'
import { handleError, handleSuccess } from 'Helpers'
import { ToastContainer } from 'react-toastify'
import { KycType } from 'Models/KycType'
import kycServices from 'Services/kycServices'

const InvestorsKycDetails = () => {
  const { id } = useParams()

  const [, setLoading] = useState(false)

  const [kyc, setKyc] = useState<KycType>()

  const [previewUrl, setPreviewUrl] = useState<string | undefined>()
  const [previewType, setPreviewType] = useState<'image' | 'pdf'>('image')

  const getKyc = async () => {
    setLoading(true)
    await kycServices.getSingle(id).then(
      (response) => {
        setLoading(false)
        setKyc(response?.data.data)
        console.log('KYC Card response', response)
      },
      (error: { response: object }) => {
        setLoading(false)
      },
    )
  }

  useEffect(() => {
    getKyc()
  }, [id])

  const handleApprove = async (kycId: string) => {
    if (!window.confirm('Approve this KYC application?')) return

    setLoading(true)
    await kycServices.approve(kycId).then(
      () => {
        getKyc()
        setLoading(false)
        handleSuccess('Application Approved succesfully')
      },
      (error) => {
        setLoading(false)
        handleError(error)
      },
    )
  }

  const handleReject = async (kycId: string) => {
    const reason = confirm('Are you sure you want to reject this KYC application?')

    if (reason === false) return

    setLoading(true)
    await kycServices.reject(kycId).then(
      () => {
        getKyc()
        setLoading(false)
        handleSuccess('Application rejected succesfully')
      },
      (error) => {
        setLoading(false)
        handleError(error)
      },
    )
  }

  const openPreview = (url: string) => {
    const isPdf = url.toLowerCase().endsWith('.pdf')
    setPreviewType(isPdf ? 'pdf' : 'image')
    setPreviewUrl(url)
  }

  const closePreview = () => {
    setPreviewUrl(undefined)
  }

  return (
    <div className='tradersCardDetails mb-5'>
      {' '}
      <div className='container mt-4'>
        <BreadCrumb
          title={'Details'}
          parent={'KYC'}
          parentUrl={'-1'}
          showTitle={false}
        ></BreadCrumb>
        <div className='row mt-3'>
          <div className='col-12 col-sm-12 col-md-4 col-lg-4 col-xl-8 my-auto'>
            <div className='title'>
              {kyc?.companyName} KYC{' '}
              {kyc?.status === 'APPROVED' ? (
                <span className='status-approved'>{kyc?.status}</span>
              ) : (
                <span className='status-pending'>{kyc?.status}</span>
              )}
            </div>
          </div>

          <div className='col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4 text-md-end'>
            {kyc?.status !== 'REJECTED' && (
              <button className='btn btn-decline' onClick={() => handleReject(String(id))}>
                Decline
              </button>
            )}

            {kyc?.status !== 'APPROVED' && (
              <button className='btn btn-approve ms-3' onClick={() => handleApprove(String(id))}>
                Approve
              </button>
            )}
          </div>
        </div>

        <div className='row'>
          <div className='col-md-7'>
            <div className='sub-title mb-2 mt-4'>Company details</div>
            <div className='card border-0'>
              <div className='card-body'>
                <div className='row'>
                  <div className='col-6 col-md-4 list-item'>
                    <div className='label'>Customer</div>
                    <div className='value'>{kyc?.companyName}</div>
                  </div>
                  <div className='col-6 col-md-4  list-item'>
                    <div className='label'>Registration Type</div>
                    <div className='value'>{kyc?.businessType ?? '-'}</div>
                  </div>
                  <div className='col-6 col-md-4  list-item'>
                    <div className='label'> Company Email Address </div>
                    <div className='value'>{kyc?.companyEmailAddress ?? '-'}</div>
                  </div>
                  <div className='col-6 col-md-4  list-item'>
                    <div className='label'>Company Phone Number</div>
                    <div className='value'>{kyc?.companyPhoneNumber ?? '-'}</div>
                  </div>
                  <div className='col-6 col-md-4  list-item'>
                    <div className='label'>RC Number</div>
                    <div className='value'>{kyc?.rcNumber ?? '-'}</div>
                  </div>
                  <div className='col-6 col-md-4  list-item'>
                    <div className='label'>Company Address</div>
                    <div className='value'>{kyc?.registeredCompanyAddress ?? '-'}</div>
                  </div>
                  <div className='col-6 col-md-4  list-item'>
                    <div className='label'>TIN Number</div>
                    <div className='value'>{kyc?.tinNumber ?? '-'}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='col-md-12'>
            <div className='sub-title mb-2 mt-4'>Uploaded Legal Documents</div>
            <div className='card border-0 py-3'>
              <div className='card-body'>
                <div className='row'>
                  {kyc?.verificationDocuments &&
                    kyc.verificationDocuments.map((docs, index: Key) => {
                      return (
                        <div className='col-12 col-md-5 mb-5' key={index}>
                          <div className='row'>
                            <div className='col-8 col-md-5'>
                              <div className='image-card'>
                                <img src={docs.url} className='w-100'></img>
                                <div className='d-flex'>
                                  <button className='btn' onClick={() => openPreview(docs.url)}>
                                    <svg
                                      width='23'
                                      height='23'
                                      viewBox='0 0 23 23'
                                      fill='none'
                                      xmlns='http://www.w3.org/2000/svg'
                                    >
                                      <path
                                        d='M11.433 15.5585C9.15596 15.5585 7.30762 13.7101 7.30762 11.433C7.30762 9.15596 9.15596 7.30762 11.433 7.30762C13.7101 7.30762 15.5585 9.15596 15.5585 11.433C15.5585 13.7101 13.7101 15.5585 11.433 15.5585ZM11.433 8.73675C9.94675 8.73675 8.73675 9.94675 8.73675 11.433C8.73675 12.9193 9.94675 14.1293 11.433 14.1293C12.9193 14.1293 14.1293 12.9193 14.1293 11.433C14.1293 9.94675 12.9193 8.73675 11.433 8.73675Z'
                                        fill='#292D32'
                                      />
                                      <path
                                        d='M11.433 20.0266C7.85068 20.0266 4.46839 17.9305 2.14367 14.291C1.13375 12.7189 1.13375 10.156 2.14367 8.57445C4.47792 4.93493 7.8602 2.83887 11.433 2.83887C15.0059 2.83887 18.3882 4.93493 20.7129 8.57445C21.7228 10.1465 21.7228 12.7094 20.7129 14.291C18.3882 17.9305 15.0059 20.0266 11.433 20.0266ZM11.433 4.268C8.35564 4.268 5.41162 6.11635 3.35367 9.34619C2.6391 10.4609 2.6391 12.4045 3.35367 13.5193C5.41162 16.7491 8.35564 18.5974 11.433 18.5974C14.5104 18.5974 17.4545 16.7491 19.5124 13.5193C20.227 12.4045 20.227 10.4609 19.5124 9.34619C17.4545 6.11635 14.5104 4.268 11.433 4.268Z'
                                        fill='#292D32'
                                      />
                                    </svg>
                                  </button>

                                  <Link to={docs.url} target='_blank' rel='noreferrer'>
                                    <button className='btn'>
                                      <svg
                                        width='20'
                                        height='20'
                                        viewBox='0 0 23 23'
                                        fill='none'
                                        xmlns='http://www.w3.org/2000/svg'
                                      >
                                        <path
                                          d='M8.57492 16.9113C8.47964 16.9113 8.39389 16.8922 8.29862 16.8541C8.03185 16.7493 7.86035 16.4826 7.86035 16.1967V10.4802C7.86035 10.0896 8.18429 9.76562 8.57492 9.76562C8.96555 9.76562 9.28948 10.0896 9.28948 10.4802V14.4722L9.97547 13.7863C10.2518 13.51 10.7091 13.51 10.9854 13.7863C11.2617 14.0626 11.2617 14.5199 10.9854 14.7962L9.07988 16.7017C8.94649 16.8351 8.75594 16.9113 8.57492 16.9113Z'
                                          fill='#292D32'
                                        />
                                        <path
                                          d='M8.57473 16.9114C8.3937 16.9114 8.21268 16.8447 8.06977 16.7018L6.16426 14.7962C5.88796 14.5199 5.88796 14.0626 6.16426 13.7863C6.44055 13.51 6.89788 13.51 7.17418 13.7863L9.07969 15.6918C9.35599 15.9681 9.35599 16.4255 9.07969 16.7018C8.93677 16.8447 8.75575 16.9114 8.57473 16.9114Z'
                                          fill='#292D32'
                                        />
                                        <path
                                          d='M14.2913 21.6756H8.57477C3.40131 21.6756 1.19092 19.4653 1.19092 14.2918V8.57526C1.19092 3.4018 3.40131 1.19141 8.57477 1.19141H13.3385C13.7292 1.19141 14.0531 1.51534 14.0531 1.90597C14.0531 2.2966 13.7292 2.62054 13.3385 2.62054H8.57477C4.18257 2.62054 2.62005 4.18306 2.62005 8.57526V14.2918C2.62005 18.684 4.18257 20.2465 8.57477 20.2465H14.2913C18.6835 20.2465 20.246 18.684 20.246 14.2918V9.52802C20.246 9.13739 20.57 8.81345 20.9606 8.81345C21.3512 8.81345 21.6752 9.13739 21.6752 9.52802V14.2918C21.6752 19.4653 19.4648 21.6756 14.2913 21.6756Z'
                                          fill='#292D32'
                                        />
                                        <path
                                          d='M20.9606 10.2422H17.1496C13.8912 10.2422 12.624 8.97499 12.624 5.71656V1.90554C12.624 1.61972 12.7955 1.35294 13.0623 1.24814C13.3291 1.13381 13.6339 1.2005 13.8436 1.40058L21.4656 9.02263C21.6657 9.2227 21.7324 9.53711 21.618 9.80388C21.5037 10.0707 21.2465 10.2422 20.9606 10.2422ZM14.0532 3.63003V5.71656C14.0532 8.17467 14.6915 8.81302 17.1496 8.81302H19.2361L14.0532 3.63003Z'
                                          fill='#292D32'
                                        />
                                      </svg>
                                    </button>
                                  </Link>
                                </div>
                              </div>{' '}
                            </div>
                          </div>

                          <div className='image-card-title'>{formatString(docs.fileCategory)}</div>
                        </div>
                      )
                    })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModalWrapper
        showModal={previewUrl != undefined}
        closeModal={() => closePreview()}
        title='Document Preview'
        hideHeader={false}
        size={'xl'}
      >
        {previewType === 'image' ? (
          <img
            src={previewUrl}
            alt='Preview'
            className='img-fluid rounded'
            style={{ maxHeight: '75vh' }}
          />
        ) : (
          <iframe src={previewUrl} title='PDF Preview' width='100%' height='600px'></iframe>
        )}
      </ModalWrapper>
      <ToastContainer></ToastContainer>
    </div>
  )
}

export default InvestorsKycDetails
